interface Props {
  value: string;
  maxLength: number;
  onChange: (text: string) => void;
  autoFocus?: boolean;
}

// Quotes are always attributed by name in the department report; the
// question's help text says so.
const QuoteQuestion: React.FC<Props> = ({ value, maxLength, onChange, autoFocus }) => (
  <div>
    <textarea
      autoFocus={autoFocus}
      value={value}
      maxLength={maxLength}
      rows={4}
      onChange={(e) => onChange(e.target.value)}
      placeholder="It cut my report time in half and the drafts read the way I'd write them…"
      className="w-full rounded-xl border border-base-300 bg-base-100 px-4 py-3 text-sm text-base-content placeholder:text-base-content/40 outline-none focus:border-blue-500 transition-colors resize-none"
    />
    <div className="mt-1 text-right text-[11px] text-base-content/40 tabular-nums">
      {value.length}/{maxLength}
    </div>
  </div>
);

export default QuoteQuestion;
